import dayjs from "dayjs";
import {
  EventAvailabilityDetails,
  EventDetails,
  EventStatus,
  EventType,
} from "features/types";
import lowerCase from "lodash/lowerCase";
import startCase from "lodash/startCase";

export const formatEventDate = (
  event: EventDetails | EventAvailabilityDetails,
  format?: string,
): string => {
  let eventStatus: EventStatus;

  if (event.hasOwnProperty("status")) {
    eventStatus = (event as EventDetails).status;
  } else {
    eventStatus = (event as EventAvailabilityDetails).eventStatus;
  }
  if (eventStatus !== "NORMAL") {
    return eventStatus;
  }

  let predefinedFormat = "";
  if (event.containsTime === false) {
    predefinedFormat = "ddd, MMM D";
  } else {
    predefinedFormat = "ddd, MMM D - h:mm a";
  }
  return dayjs(event.localDate)
    .tz(event.timezone)
    .format(format || predefinedFormat);
};

export const SPORT_EVENT_TYPES: { [key: string]: string } = {
  BASEBALL: "Baseball",
  BASKETBALL: "Basketball",
  FOOTBALL: "Football",
  HOCKEY: "Hockey",
  SOCCER: "Soccer",
  MINOR_HOCKEY: "Minor Hockey",
  MBB: "M Basketball",
  WBB: "W Basketball",
  WVB: "W Volleyball",
  GYMNASTICS: "Gymnastics",
  WGYM: "W Gymnastics",
  WSOC: "W Soccer",
  MINOR_BASKETBALL: "Basketball",
  WSB: "W Softball",
  COLLEGE_BASEBALL: "Baseball",
  MSOC: "M Soccer",
  MINOR_BASEBALL: "Baseball",
  MINOR_SOCCER: "Soccer",
  VOLLEYBALL: "Volleyball",
  WOMENS_BASKETBALL: "W Basketball",
  LACROSSE: "Lacrosse",
  INDOOR_FOOTBALL: "Indoor Football",
  MISC_SPORTS: "Misc Sports",
};

export const isSportsEvent = (eventType: EventType) => {
  return SPORT_EVENT_TYPES[eventType] !== undefined;
};

export const eventTypeDisplay = (eventType: EventType) => {
  if (SPORT_EVENT_TYPES[eventType]) {
    return SPORT_EVENT_TYPES[eventType];
  }
  // acronym event types should stay uppercase
  if (eventType === "NIL" || eventType === "RSVP") {
    return eventType;
  }
  return startCase(lowerCase(eventType));
};
